import { Row, Label, Column } from './styled'
import { Switch } from '@sabavision/dio'
import { useTranslation } from 'react-i18next'
import { Istate } from '../../../reducers/types'
import { useSelector, useDispatch } from 'react-redux'
import { retrieveOwnerData, updateUserData } from '../../../actions/user'

function ViewSetting() {
  const { t } = useTranslation('translation', { keyPrefix: 'sidebar' })
  const dispatch = useDispatch()
  const user = useSelector((state: Istate) => state.user)

  const handleRequest = (view: 'ads_gallery' | 'report' | 'campaign_program_list', state: string | number) => {
    const appearance_settings: any = user.appearance_settings
    appearance_settings[view] = state

    dispatch(updateUserData({ ...{ unique_id: user.unique_id, appearance_settings } }))
    setTimeout(() => {
      dispatch(retrieveOwnerData())
    }, 3000)
  }

  return (
    <Column>
      <Row className="space-between">
        <div>
          <span>
            <Label className="label">{t('campaign_program_list_view')}</Label>
          </span>
          <Switch
            values={[
              {
                label: t('all_archived_non_archived'),
                name: 'ALL'
              },
              {
                label: t('non_archived'),
                name: 'NON_ARCHIVED'
              }
            ]}
            defaultValue={user.appearance_settings?.campaign_program_list}
            handleToggle={(newValue) => handleRequest('campaign_program_list', newValue)}
          />
        </div>
      </Row>
      <Row className="space-between">
        <div>
          <span>
            <Label className="label">{t('report_view')}</Label>
          </span>
          <Switch
            values={[
              {
                label: t('advanced_charts'),
                name: 'ADVANCED'
              },
              {
                label: t('simple_charts'),
                name: 'BASIC'
              }
            ]}
            defaultValue={user.appearance_settings?.report}
            handleToggle={(newValue) => handleRequest('report', newValue)}
          />
        </div>
      </Row>
      <Row className="space-between">
        <div>
          <span>
            <Label className="label">{t('ads_gallery_view')}</Label>
          </span>
          <Switch
            values={[
              {
                label: t('list_view'),
                name: 'LIST'
              },
              {
                label: t('cart_view'),
                name: 'GRID'
              }
            ]}
            defaultValue={user.appearance_settings?.ads_gallery}
            handleToggle={(newValue) => handleRequest('ads_gallery', newValue)}
          />
        </div>
      </Row>
    </Column>
  )
}

export default ViewSetting
